/* @flow */

import { DIRETORIO_IMAGENS_UPLOAD } from './constants';

const criarDiretorioImagensUpload = (s: string): string => DIRETORIO_IMAGENS_UPLOAD.concat(s);

export default criarDiretorioImagensUpload;
